/**
 * Koniec zápasu: veľký nápis v strede dosky. Ukáže sa až po dohraní scény
 * súboja — posledný úder musí byť vidieť skôr, než príde výsledok.
 *
 * `winner` je číslo TÍMU (v duele a FFA zhodné s hráčom, v 2v2 nie). V online
 * hre a proti botovi vidí porazený DEFEAT; v hot-seate hráš za všetkých, takže
 * je to vždy WIN s menom víťaza.
 */

import type { PublicState } from '../api.js';

interface Props {
  state: PublicState;
  /** Môj tím — `null` v hot-seate. */
  myTeam: number | null;
  nameOf: (player: number) => string;
  onClose: () => void;
  onLeave: () => void;
}

export function GameOver({ state, myTeam, nameOf, onClose, onLeave }: Props) {
  const winner = state.winner ?? 0;
  const winners = state.players.filter((p) => p.team === winner).map((p) => p.index);
  const won = myTeam === null || myTeam === winner;
  const who =
    state.format === 'teams'
      ? `Tím ${winner === 0 ? 'A' : 'B'} · ${winners.map(nameOf).join(' + ')}`
      : winners.map(nameOf).join(' + ');

  return (
    <div
      className={`gameOver gameOver--p${winners[0] ?? 0} ${won ? 'is-win' : 'is-defeat'}`}
      role="dialog"
      aria-modal="false"
      aria-labelledby="gameOverTitle"
    >
      <div className="gameOver__band">
        <span className="gameOver__kicker">Koniec zápasu</span>
        <h2 id="gameOverTitle" className="gameOver__title">
          {won ? 'WIN' : 'DEFEAT'}
        </h2>
        <span className="gameOver__who">
          {won && myTeam !== null ? 'Víťazstvo · ' : 'Víťaz · '}
          {who}
        </span>
        <div className="gameOver__actions">
          <button type="button" className="btn btn--ghost" onClick={onClose}>
            Pozrieť dosku
          </button>
          <button type="button" className="btn btn--primary" onClick={onLeave}>
            Späť do klubovne
          </button>
        </div>
      </div>
    </div>
  );
}
